module.exports = __webpack_public_path__ + "img/menuBg.5839a0e1.png";